import { SINGLE_PHOTOGRAPHER_FETCH_REQUEST, SINGLE_PHOTOGRAPHER_FETCH_SUCCESS, SINGLE_PHOTOGRAPHER_FETCH_FAILURE } from './types';

const initialState = {
    loading: false,
    sphotographer: {},
    error: ''
}

const sphotographer = (state = initialState, action) => {
    switch (action.type) {
        case SINGLE_PHOTOGRAPHER_FETCH_REQUEST:
            return {
                loading: true,
                sphotographer: {},
                error: '',
            }
        case SINGLE_PHOTOGRAPHER_FETCH_SUCCESS:
            return {
                loading: false,
                sphotographer: action.payload,
                error: ''
            }
        case SINGLE_PHOTOGRAPHER_FETCH_FAILURE:
            return {
                loading: false,
                sphotographer: {},
                error: action.payload
            }
        default:
            return state
    }
}

export default sphotographer;